import { SimpleCache } from '../../../components/src';
import { BfiApi, IApiResponse } from './bfiApi';

export interface IListItem {
    key: string;
    name: string;
}

// eslint-disable-next-line no-undef
export interface IListItemResponse extends Omit<IApiResponse, 'result'> {
    result: [IListItem];
}

const listCache = new SimpleCache(60);

export class ListApi extends BfiApi {
    _getAndCache(key: string, url: string) {
        const data = listCache.get(key);
        if (!data) {
            const retVal = new Promise<[IListItem]>((resolve, reject) => {
                super.get<IListItemResponse>(url).then((response) => {
                    resolve(response.result);
                });
            });
            listCache.set(key, retVal);
            return retVal;
        }
        return data;
    }

    getIccas(): Promise<IListItemResponse> {
        //Not caching as it can cache via the UI
        return super.get('/list/getIccas');
    }

    getGoogleFonts(): Promise<[IListItem]> {
        return this._getAndCache('googleFonts', '/list/getGoogleFonts');
    }

    getActiveBrokerList(): Promise<IListItemResponse> {
        //Not caching as it can cache via the UI
        return super.get('/list/getActiveBrokerList');
    }

    getBfiEmployees(): Promise<[IListItem]> {
        return this._getAndCache('employees', '/list/getBfiEmployeeList');
    }

    getLoanExpenseTypesPreClosing(): Promise<[IListItem]> {
        return this._getAndCache('loanExpenseTypesPreClosing', '/list/loans/expensetypes/preclosing');
    }

    getLoanExpenseTypesPostClosing(): Promise<[IListItem]> {
        return this._getAndCache('loanExpenseTypesPostClosing', '/list/loans/expensetypes/postclosing');
    }

    getBrokerFeeTypes(): Promise<[IListItem]> {
        return this._getAndCache('brokerFeeTypes', '/list/broker/feetypes');
    }

    getLoanInterestTypes(): Promise<[IListItem]> {
        return this._getAndCache('loanInterestTypes', '/list/loans/interesttypes');
    }

    getLoanInterestPaymentDueTypes(): Promise<[IListItem]> {
        return this._getAndCache('interestpaymentduetypes', '/list/loans/interestpaymentduetypes');
    }

    getIncompleteReasonsForNotice(noticeId: number): Promise<[IListItemResponse]> {
        return super.get(`/list/notices/${noticeId}/incompletereasons`);
    }

    getIncompleteReasonsForLoan(loanId: number): Promise<[IListItemResponse]> {
        return super.get(`/list/loans/${loanId}/incompletereasons`);
    }

    getIncompleteReasonsForApplication(applId: number): Promise<[IListItemResponse]> {
        return super.get(`/list/applications/${applId}/incompletereasons`);
    }
}
